declare namespace $ {

	export class $shm_service_workspace extends $mol_book2 {
		workspace_pages( ): readonly(any)[]
		task_list( ): $mol_view | null
		dashboard( ): $mol_view | null
		filters( ): $mol_view | null
		pages( ): ReturnType< $shm_service_workspace['workspace_pages'] >
	}
	
}

//# sourceMappingURL=workspace.view.tree.d.ts.map